export default __webpack_public_path__ + "static/1-991509a5a0086e9c9b3df85f9f53b625.png";